/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserFileStatusCountsResponse interface.
 */
export function instanceOfUserFileStatusCountsResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function UserFileStatusCountsResponseFromJSON(json) {
    return UserFileStatusCountsResponseFromJSONTyped(json, false);
}
export function UserFileStatusCountsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'all': !exists(json, 'all') ? undefined : json['all'],
        'needsAttention': !exists(json, 'needsAttention') ? undefined : json['needsAttention'],
        'failed': !exists(json, 'failed') ? undefined : json['failed'],
        'threat': !exists(json, 'threat') ? undefined : json['threat'],
        'processing': !exists(json, 'processing') ? undefined : json['processing'],
        'pendingScan': !exists(json, 'pendingScan') ? undefined : json['pendingScan'],
        'queued': !exists(json, 'queued') ? undefined : json['queued'],
    };
}
export function UserFileStatusCountsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'all': value.all,
        'needsAttention': value.needsAttention,
        'failed': value.failed,
        'threat': value.threat,
        'processing': value.processing,
        'pendingScan': value.pendingScan,
        'queued': value.queued,
    };
}
